import styled from "@emotion/styled/macro";
import { TypographyT29, TypographyT30, TypographyT31 } from "Components/Common/Typography/index";
import React from "react";


const RFQInformationTable = () => {
  return (
    <RFQInformationTableWrapper>
      <Table>
        <THead>
          <Tr>
            <Th></Th>
            <Th>
              <TypographyT29 variant="h5">RFQ</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5"> LOI Accepted Date</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5"> Contract Period</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5">L1 Rate (per MT)</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5"> Vehicle Type</TypographyT29>
            </Th>
            <Th>
              <TypographyT29 variant="h5"> Transporter</TypographyT29>
            </Th>
          </Tr>
        </THead>
        <TBody>
          <Tr>
            <Td>
              <TypographyT30 variant="h6"> 1</TypographyT30>
            </Td>
            <Td>
              <TypographyT31 variant="h5"> RFQ1</TypographyT31>
            </Td>
            <Td>
              <TypographyT31 variant="h5"> 22/06/2022</TypographyT31>
            </Td>
            <Td>
              <TypographyT31 variant="h5">
                22/06/2022 - 22/06/2022
              </TypographyT31>
            </Td>
            <Td>
              <TypographyT31 variant="h5">5900</TypographyT31>
            </Td>
            <Td>
              <TypographyT31 variant="h5">20 MT</TypographyT31>
            </Td>
            <Td>
              <TypographyT31 variant="h5">Inter India</TypographyT31>
            </Td>
          </Tr>
        </TBody>
      </Table>
    </RFQInformationTableWrapper>
  );
};

export default RFQInformationTable;

const RFQInformationTableWrapper = styled.div`
  overflow: auto;
  box-shadow: 0px 0px 10px 0px rgba(82, 138, 234, 0.36);
  border-radius: 5px;
`;

const Table = styled.table`
  width: 100%;
  border-spacing: 0px;
  border-radius: 5px;
  background: #fff;
`;
const THead = styled.thead``;
const TBody = styled.tbody``;
const Th = styled.th`
  text-align: left;
  background-color: #e7edfa;
  padding: 10px;
`;
const Td = styled.td`
  padding: 10px;
  background-color: #fff;
`;

const Tr = styled.tr`
  &:first-of-type ${Td} {
    border-bottom: 1px solid #e7edfa;
  }
`;
